import * as Sentry from '@sentry/browser';

let instance = null;

/**
 * https://docs.sentry.io/error-reporting/capturing/?platform=javascript
 */
export class sentryInstance {

    constructor() {
        if (instance === null) {
            this.dsn = 'https://d62ee94822a24c2eb5b17de2b64a7f21@o405064.ingest.sentry.io/5270089';
            this.production = process.env.NODE_ENV === 'production';
            if (this.production) {
                Sentry.init({dsn: this.dsn});
            }
            instance = this;
        }
        return instance;
    }

    captureMessage(messageStr) {
        if (this.production) {
            Sentry.captureMessage(messageStr);
        }
    }

    captureException(exception, contextObject) {
        if (this.production) {
            Sentry.captureException(exception, contextObject);
        }
    }

}